// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "Video-module--bx--text-truncate--end--huJpl";
export var bxTextTruncateFront = "Video-module--bx--text-truncate--front--r9LDU";
export var skeleton = "Video-module--skeleton--olNLl";
export var video = "Video-module--video--+JRuy";
export var videoButton = "Video-module--video-button--qpsyi";
export var videoContainer = "Video-module--video-container--KufuS";
export var videoIsPlaying = "Video-module--video--is-playing--4U7RQ";
export var vimeo = "Video-module--vimeo--d9d8j";